export const CRYPTO_TEST_MIGRATION_VERSIONS = Object.freeze(["v1", "v2"]);

const STORAGE_KEY = "sia.benchmarking.cryptoMigrationTest";
const QUERY_PARAM = "cryptoMigrationTest";
const ENABLE_VALUES = new Set(["1", "true", "on"]);
const DISABLE_VALUES = new Set(["0", "false", "off"]);

const consumeQueryFlag = () => {
  if (typeof window === "undefined") return null;

  const params = new URLSearchParams(window.location.search);
  const value = params.get(QUERY_PARAM)?.toLowerCase();

  if (!ENABLE_VALUES.has(value) && !DISABLE_VALUES.has(value)) return null;

  params.delete(QUERY_PARAM);

  const query = params.toString();
  const nextUrl = `${window.location.pathname || ""}${query ? `?${query}` : ""}${window.location.hash || ""}`;

  window.history?.replaceState?.(window.history.state, "", nextUrl);

  return ENABLE_VALUES.has(value);
};

export function isCryptoTestMigrationEnabled() {
  if (typeof window === "undefined" || typeof sessionStorage === "undefined") return false;

  const requestedState = consumeQueryFlag();

  if (requestedState === true) {
    sessionStorage.setItem(STORAGE_KEY, "true");
  } else if (requestedState === false) {
    sessionStorage.removeItem(STORAGE_KEY);
  }

  return sessionStorage.getItem(STORAGE_KEY) === "true";
}

export function disableCryptoTestMigration() {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem(STORAGE_KEY);
  }
}
